(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const cartForm = document.querySelector('#ShrvyCart');
  if (cartForm) {
    let updateTimer;
    cartForm.addEventListener('change', (event) => {
      if (!event.target.matches('[name="updates[]"]')) return;
      const status = cartForm.querySelector('[data-cart-update-status]');
      if (status) status.textContent = status.dataset.updatingLabel;
      clearTimeout(updateTimer);
      updateTimer = setTimeout(() => cartForm.requestSubmit(), 350);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
